/**
 * 各种 Push 消息对应的 Code
 */
enum PushCode {
    /** 新订单 */
    NEW_ORDER_1 = 1,
    /** 门店营业状态变更 */
    POI_BUSINESS_STATUS_CHANGE_2 = 2,
    /** 确认订单 */
    ORDER_CONFIRMED_3 = 3,
    /** 顾客申请退款、申诉 */
    APPLY_REFUND_4 = 4,
    /** 预订单通知 */
    PRE_ORDER_NOTICE_6 = 6,
    /** (美团)客服置休 */
    CUSTOMER_SERVICE_SET_REST_8 = 8,
    /** 催单 */
    REMIND_ORDER_9 = 9,
    /** 配送营业时间调整 */
    SHIPPING_TIME_CHANGE_10 = 10,
    /** 活动通知 */
    ACTIVITY_NOTICE_11 = 11,
    /** 订单配送状态变更 */
    LOGISTICS_STATUS_CHANGE_12 = 12,
    /** 心跳置休 */
    HEARTBEAT_SET_REST_13 = 13,
    /** 普通(手动)置休 */
    NORMAL_SET_REST_14 = 14,
    /** 订单完成(订单状态变为8) */
    ORDER_COMPLETED_16 = 16,
    /** 订单完成(订单状态变为9) */
    ORDER_CANCELLED_17 = 17,
    /** 门店业务经理变更 */
    BD_CHANGED_18 = 18,
    /** 排序特权到期提醒 */
    POI_WEIGHTING_PRIVILEGE_21 = 21,
    /** 菜品同步通知 */
    PRODUCT_SYNC_NOTICE_22 = 22,
    /** 订单结算信息变更 */
    CHARGE_DETAIL_CHANGE_24 = 24,
    /** 评价举报结果通知 */
    COMMENT_REPORT_RESULT_25 = 25,
    /** 订单配送异常(包括异常产生与恢复) */
    LOGISTICS_EXCEPTION_26 = 26,
    /** IM消息两分钟未回复提醒 */
    IM_NOT_REPLY_IN_2MIN_27 = 27,
    /** 出餐完成 */
    MAKE_MEAL_DONE_28 = 28,
    /** 出餐异常(骑手上报商家出餐慢) */
    MAKE_MEAL_SLOW_REPORTED_29 = 29,
    /** 强制结束卡餐生效状态push通知 */
    FORCE_QUIT_MAKE_MEAL_SLOW_STATE_30 = 30,
    /** 防漏单提醒（订单即将超时取消） */
    ORDER_WILL_TIMEOUT_31 = 31,
    /** 企客运力变更 */
    QIKE_DELIVERY_CAPACITY_CHANGE_32 = 32,
    /** 配送爆单(运力不足) */
    DELIVERY_CAPACITY_INSUFFICIENT_51 = 51,
    /** 配送爆单结束(运力恢复) */
    DELIVERY_CAPACITY_BACK_TO_NORMAL_52 = 52,
    /** 卡餐提醒 */
    MAKE_MEAL_SLOW_RISK_REMIND_53 = 53,
    /** 小票打印设置成功(需要通知端上重新拉取最新设置) */
    RECEIPT_PRINT_CONFIG_CHANGED_55 = 55,
    /** 跑腿权益生效状态变更 */
    PAOTUI_RIGHTS_TAKE_EFFECT_56 = 56,
    /** PHF拼单一起送客服赔付状态变更 */
    PHF_COMBINE_CS_COMPENSATE_STATUS_CHANGE_57 = 57,
    /** 智能客服入口状态文案变更 */
    AI_CS_ENTRANCE_TEXT_CHANGE_58 = 58,
    /** 配送压单状态变更 */
    DELIVERY_SUSPEND_STATUS_CHANGE_61 = 61,
    /** 新订单预计收入为负提醒 */
    NEGATIVE_INCOME_REMIND_62 = 62,
    /** 定责状态变更*/
    ORDER_DUTY_STATUS_63 = 63,
    /** 预订单备餐提醒 */
    PRE_ORDER_ACCEPTED_BY_RIDER_64 = 64,
    /** 解除拉黑骑手提醒 */
    UNBLOCK_RIDER_NOTICE_66 = 66,
    /** 待退款申诉 */
    REFUND_CAN_APPEAL_99 = 99,
    /** 特殊天气/节日提醒 */
    WEATHER_HOLIDAY_REMIND_101 = 101,
    /** 评价提醒 */
    COMMENT_REMIND_102 = 102,
    /** 自动发配送失败 */
    AUTO_SEND_DELIVERY_FAIL_103 = 103,

    /** 绑定三方配送服务结果 */
    BIND_THIRD_PARTY_DELIVERY_RESULT_104 = 104,
    /** 三方配送询价结果 */
    THIRD_PARTY_DELIVERY_QUERY_FEE_RESULT_105 = 105,
    /** 三方配送加小费结果 */
    THIRD_PARTY_DELIVERY_ADD_TIPS_RESULT_106 = 106,
    /** 三方配送取消配送结果 */
    THIRD_PARTY_DELIVERY_CANCEL_DELIVERY_RESULT_107 = 107,

    /** 系统异常提醒 */
    SYSTEM_EXCEPTION_NOTICE_119 = 119,

    /** 意见反馈收到回复 */
    FEEDBACK_REPLY_120 = 120,

    /** 预售单 新订单 */
    PREPARATION_NEW_ORDER_121 = 121,

    /** 预售单 出餐提醒 */
    PREPARATION_PREP_MEAL_ORDER_122 = 122,

    /** 预售单取消 */
    PREPARATION_CANCEL_ORDER_123 = 123,

    /** 用户发起 ETA 变更申请 */
    ETA_CHANGE_REQUEST_124 = 124,

    /** 业务消息通知(站内信) */
    BUSINESS_MESSAGE_NOTICE_999 = 999,

    /** 统一触达消息 */
    UNIFIED_BUSINESS_MESSAGE_NOTICE_1010 = 1010,

    /** 强制前端刷新页面 */
    FORCE_CLIENT_REFRESH_2000 = 2000,

    /** 转自配按钮实时刷新 */
    SELF_DELIVERY_BUTTON_AUTO_REFRESH_3005 = 3005,

    /** 食安相关状态变更（赔付状态、放心吃状态） */
    FOOD_SAFETY_STATUS_CHANGE_3006 = 3006,

    /** 换骑手 */
    DISPATCHER_CHANGE_3007 = 3007,

    /** 预订单备餐兜底提醒 */
    PRE_ORDER_PREP_MEAL_FALLBACK_REMIND_3008 = 3008,

    /** 出餐申诉超时 */
    PREP_MEAL_APPEAL_TIMEOUT_3009 = 3009,

    /** 转自配可用次数变化 */
    SELF_DELIVERY_AVAILABLE_LIMIT_CHANGED_3011 = 3011,

    /** 用户催促商家审核退款 */
    REFUND_URGE_3012 = 3012,

    /** 通用的订单信息刷新通知 */
    REFRESH_ORDER_INFO_3013 = 3013,

    /** 负订单通知 */
    NEGATIVE_ORDER_NOTICE_3020 = 3020,
    /** IM消息铃声动态提醒（首条、两分钟、十分钟、自定义定时任务） */
    IM_MESSAGE_REMIND_4000 = 4000,
    /** 规则中心预警通知 */
    RULE_CENTER_WARNING_5000 = 5000,
    /** 补送的售后状态变更 */
    RESEND_MEAL_AFTER_SALE_STATUS_CHANGE_3015 = 3015,
    /** 补送订单配送被取消 */
    RESEND_MEAL_CANCEL_3016 = 3016,
    /** 动态tab设置需要透传刷新页面(账号维度) */
    TAB_SETTING_REFRESH_3018 = 3018,
}
export default PushCode;
